"use client";

/**
 * Plugin SDK — First-party bootstrap.
 *
 * Phase 25-AB Task 15: Plugin SDK foundation.
 *
 * Loads the three first-party plugins exactly once per JS context.
 * Safe to call from multiple components — the `booted` latch dedupes.
 */

import { exportMultiPlugin } from "@/plugins/export-multi/plugin";
import { magicWandPlugin } from "@/plugins/magic-wand/plugin";
import { narrationPlugin } from "@/plugins/narration/plugin";
import { registry } from "./registry";

let booted = false;
let inFlight: Promise<void> | null = null;

export async function bootstrapPlugins(): Promise<void> {
	if (booted) return;
	if (inFlight) return inFlight;
	inFlight = (async () => {
		await registry.activate(narrationPlugin);
		await registry.activate(magicWandPlugin);
		await registry.activate(exportMultiPlugin);
		booted = true;
		if (typeof console !== "undefined") {
			console.log("[plugin-sdk] 3 first-party plugins loaded");
		}
	})();
	return inFlight;
}

/** Test-only reset hook. */
export function __resetBootstrap(): void {
	booted = false;
	inFlight = null;
}
